import { validate } from "uuid";

export default {
    common: {
      buttons: {
        add: '新增',
        update: '编辑',
        delete: '删除',
        query: '查询',
        reset: '重置',
        submit: '提交',
        export: '导出',
        import: '导入',
        importConfire: '确认导入',
        unValid: '校验失败',
        template: '下载模板',
        view: '查看',
        save: '保存',
        cancel: '取消',
        opt: '操作',
        upload: '上传',
        detail: '详情',
        clear: '解除',
        warningConfig: '告警配置',
        waveform: '波形图',
      },
      message: {
        pleaseInput: '请检查输入内容',
        pleaseSelect: '请选择',
        addSuccess: '新增成功',
        updateSuccess: '修改成功',
        deleteSuccess: '删除成功',
        querySuccess: '查询成功',
        saveSuccess: '保存成功',
        uploadSuccess: '上传成功',
        noData: '暂无数据...',
      },
      pagination: {
        "layout": "prev, pager, next, sizes, total",
        "prev": "上一页",
        "next": "下一页",
        "total": "共 {total} 条"
    }
    },
    pages: {
     loginLabel: {
        title: ' 欢   迎   登   录 ',
        usernameLabel: ' 账   号 ',
        passwordLabel: ' 密   码 ',
        loginButton: ' 登   录 ',
      },
      orgFormLabel: {
        parentName: '上级机构',
        companyName: '企业名称',
      },
      sysParams: {
        title: '系统参数',
        paramKey: '参数编号',
        paramName: '参数名称',
        paramDesc: '参数描述',
        paramValueZh: '参数值（中文）',
        paramValueEn: '参数值（英文）',
      },
      home: {
        electric: '雷电预警',
        location: '闪电监测',
        peak: '雷电峰值',
        resistance: '接地电阻',
        protection: '防雷器',
        rod: '避雷针',
        total: '设备总数',
        onlineRate: '设备在线率',
        onlineTitle: '在线',
        unlineTitle: '离线',
        warningRate: '设备告警率',
        nomalTitle: '正常',
        warningTitle: '告警',
      },
      deviceMgr: {
        title: '设备管理',
        dialogTitle: '设备信息',
        type: '设备分类',
        companyName: '所属单位',
        deviceId: '设备ID',
        deviceName: '设备名称',
        status: '状态',
        deviceType: '设备型号',
        lon: '经度',
        lat: '纬度',
        location: '地址',
        produceDate: '生产日期',
        installDate: '安装日期',
        protocol: '通信协议',
        imgUrl: '设备图像',
        memo: '备注',
        warningCancelTime: '告警自动解除时间(分)',
        noWarningTime: '解除后N分钟内无告警',
        r1: '内圈半径',
        r2: '中圈半径',
        r3: '外圈半径',
        isValid: '是否校验通过',
        msg: '校验异常信息',

        quantity_standard: '电池电压标准值',
        quantity_warning: '电池电压告警值',
        resistance_standard: '保护地电阻标准值',
        resistance_warning: '保护地电阻告警值',
        voltage_standard: '保护地对地接地电压标准值',
        voltage_warning: '保护地对地接地电压告警值',
        resistance2_standard: '工作地电阻标准值',
        resistance2_warning: '工作地电阻告警值',
        voltage2_standard: '工作地对地接地电压标准值',
        voltage2_warning: '工作地对地接地电压告警值',
        resistance3_standard: '防雷地电阻标准值',
        resistance3_warning: '防雷地电阻告警值',
        voltage3_standard: '防雷地对地接地电压标准值',
        voltage3_warning: '防雷地对地接地电压告警值',
        resistance4_standard: '静电地电阻标准值',
        resistance4_warning: '静电地电阻告警值',
        voltage4_standard: '静电地对地接地电压标准值',
        voltage4_warning: '静电地对地接地电压告警值',
        resistance5_standard: '屏蔽地电阻标准值',
        resistance5_warning: '屏蔽地电阻告警值',
        voltage5_standard: '屏蔽地对地接地电压标准值',
        voltage5_warning: '屏蔽地对地接地电压告警值',

      },
      electric: {
        offline: '离线',
        normal: '正常',
        warning: '告警',
        online: '在线',
        exeception: '异常',
        unknown: '未知',
        total: '总数',
        warnintTimes: '预警次数',
        hour: '小时',
        day: '天',
        offTimes: '离线次数',
        warningTimes: '告警次数',
        warningDistribution: '预警分布',
        noWarning: '无预警',
        level1: '一级预警',
        level2: '二级预警',
        level3: '三级预警',
        warningDeal: '预警处理',
        offlineRate: '离线处理率',
        warningRate: '告警处理率',
        latestWarning: '最 新 告 警',
        deviceId: '设备ID',
        deviceType: '设备型号',
        deviceName: '设备名称',
        dataTime: '更新时间',
        datas: '观测数据',
        companyName: '所属企业',
        location: '设备地址',
        lonlat: '经纬度',
        status: '状态',
        installDate: '安装日期',
        updateTime: '更新时间',
        queryBtn: '设备查询',
        warningBtn: '告警记录',
        historyBtn: '历史数据',
        repairBtn: '维修记录',
        deviceList: '设备列表',
        latestData: '最新观测',
        intensity: '电场强度',
        warningGrade: '告警等级',
        temp: '温度',
        precipitation: '降雨量',
        rh: '湿度',
        pressure: '气压',
        windSpeed: '风速',
        windDirection: '风向',
        more: '更多设备',

        warningTime: '告警时间',
        warningItem: '告警项',
        warningData: '告警数据',
        warningLevel: '告警等级',
        warningDesc: '告警描述',

        electricity: '雷击电流',
        lighting_type: '闪电类型',
        lighting_count: '雷电计数',
        lighting_count1: '雷击计数',
        tilt: '倾角',
        resistance: '接地电阻',
        voltage: '接地电压',
        spd1_temp: 'SPD1温度',
        spd1_leakage_all: 'SPD1漏电流',
        surge_count: '浪涌计数',
        quantity: '电池电量',
      },
      deviceMaintain: {
        title: '设备维修',
        deviceName: '设备名称',
        workOrderName: '工单名称',
        level: '工单级别',
        level10: '故障',
        level20: '巡检',
        level30: '抢修',
        description: '工单描述',
        principal: '负责人',
        type: '工单类型',
        status: '工单状态',
        createTime: '创建时间',
        deviceId: '设备ID',
        restoreTime: '修复时间',
        add: '新增工单',
        edit: '修改状态',
        query: '查询',
        save: '保存',
        cancel: '取消',
        delete: '删除',
        confirmDelete: '确定删除该工单吗？',
        successSave: '保存成功',
        successDelete: '删除成功',
        timeRange: '时间范围',
        startTime: '开始日期',
        endTime: '结束日期'
      }
    }
  }